import http from './http';

export default {
  getRounds(wheel, {
    dateFrom,
    dateTo,
    timezoneOffset,
    locale,
    pageSize,
    translations,
  }) {
    const url = `/rounds/${wheel.id}/${wheel.wheelAccountId}/${wheel.platformCompanyUuid}`;

    return http.get(url, {
      params: {
        dateFrom,
        dateTo,
        timezoneOffset,
        locale,
        pageSize,
        translations,
      },
    }).then((response) => {
      const { data } = response;
      return data;
    });
  },
};
